import qs from 'qs'

const fields = [
  'date'
]

export const queryTalkEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'en-US',
      pagination: {
        limit: 1,
      },
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        subtitles: true,
        images: true,
        descriptions: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `talk-entries?${query}`
}
